import {windowWidth} from "../common";

const $DOC = $(document);

export default class SnowQueen {
    constructor() {
        this.$el = $('#snow_queen');
        this.slide = $('.slider-single');
        this.slideTotal = this.slide.length - 1;
        this.slideCurrent = -1;

        this._slideLeft = this._slideLeft.bind(this);
        this._slideRight = this._slideRight.bind(this);

        if (this.$el.length >= 1) {
            $(".owl-carousel").owlCarousel({
                loop: true,
                nav: false,
                navText: ['', ''],
                navElement: 'div',
                dots: false,
                items: 3,
                autoplay: true,
                startPosition: 0,
                smartSpeed: 3000,
                margin: 15
            });
            $('[data-fancybox]').fancybox({
                loop : true,
                infobar : true,
                backFocus : false,
                clickSlide : 'prev',
                clickContent : function( current, event ) {
                    return current.type === 'image' ? 'next' : false;
                }
            });
        }

        (() => {
            this.slide.addClass('proactivede');
            setTimeout(() => {
                this._slideRight();
            }, 500);
        })();

        $DOC
            .on('click', '.slider-right', this._slideRight)
            .on('click', '.slider-left', this._slideLeft)
            .on('click', 'ul.tabs li', this._tabToggle)
            .on('click', '#snow_queen #tab-3 .one_block', this._videoSourceChange)
            .on('change', '.queen_reg_form_popup select', this._onChangeSelect);
    }

    _slideRight() {
        if (this.slideCurrent < this.slideTotal)
            this.slideCurrent++;
        else
            this.slideCurrent = 0;

        let preactiveSlide = this.slideCurrent > 0 ? this.slide.eq(this.slideCurrent - 1) : this.slide.eq(this.slideTotal);
        let activeSlide = this.slide.eq(this.slideCurrent);
        let proactiveSlide = this.slideCurrent < this.slideTotal ? this.slide.eq(this.slideCurrent + 1) : this.slide.eq(0);

        this.slide.each(function(i,e) {
            let thisSlide = $(e);
            if (thisSlide.hasClass('preactivede')) {
                thisSlide.removeClass('preactivede preactive active proactive').addClass('proactivede');
            }
            if (thisSlide.hasClass('preactive')) {
                thisSlide.removeClass('preactive active proactive proactivede').addClass('preactivede');
            }
        });
        preactiveSlide.removeClass('preactivede active proactive proactivede').addClass('preactive');
        activeSlide.removeClass('preactivede preactive proactive proactivede').addClass('active');
        proactiveSlide.removeClass('preactivede preactive active proactivede').addClass('proactive');
    }

    _slideLeft() {
        if (this.slideCurrent > 0)
            this.slideCurrent--;
        else
            this.slideCurrent = this.slideTotal;

        let proactiveSlide = this.slideCurrent < this.slideTotal ? this.slide.eq(this.slideCurrent + 1) : this.slide.eq(0);
        let activeSlide = this.slide.eq(this.slideCurrent);
        let preactiveSlide = this.slideCurrent > 0 ? this.slide.eq(this.slideCurrent - 1) : this.slide.eq(this.slideTotal);

        this.slide.each(function(i,e) {
            let thisSlide = $(e);
            if (thisSlide.hasClass('proactivede')) {
                thisSlide.removeClass('preactive active proactive proactivede').addClass('preactivede');
            }
            if (thisSlide.hasClass('proactive')) {
                thisSlide.removeClass('preactivede preactive active proactive').addClass('proactivede');
            }
        });
        preactiveSlide.removeClass('preactivede active proactive proactivede').addClass('preactive');
        activeSlide.removeClass('preactivede preactive proactive proactivede').addClass('active');
        proactiveSlide.removeClass('preactivede preactive active proactivede').addClass('proactive');
    }

    //переключение табов
    _tabToggle() {
        let tab_id = $(this).attr('data-tab');

        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
        $(this).parent().scrollLeft(0 + $(this).offset().left);
    }

    // Переключалка Видео внутри видео-таба
    //TODO доделать для мобайла
    _videoSourceChange() {
        if  (windowWidth > 769) {
            if (!$(this).hasClass('play_this_video')) {
                let cur_video_link = $(this).find('.img_video_prewiev').data('href');
                $('#tab-3 .one_big_block iframe').attr('src', cur_video_link);
            }
        } else {
            if (!$(this).hasClass('play_this_video')) {
                let cur_video_link = $(this).find('.img_video_prewiev').data('href');
                $(this).find('iframe').attr('src', cur_video_link);
            }
        }
        $('#tab-3 .one_block iframe').attr('src', '');
        $('#tab-3 .one_block').removeClass('play_this_video');
        $(this).addClass('play_this_video');

    }

    // TODO ПРИ НЕ CHANGE
    _onChangeSelect() {
        if ($(this).find('option:selected').val() != 'default') {
            $(this).addClass('upper');
        } else {
            $(this).removeClass('upper');
        }
    }
}